<route lang="json">
{
  "name": "zi-2024",
  "meta": {
    "fullWidth": true,
    "releaseDates": {
      "retail": "2024-10-30T16:00:00.000Z",
      "wholesale": "2024-10-30T16:00:00.000Z",
      "tester2": "2024-10-28T16:00:00.000Z"
    },
    "beforeReleaseUrl": "/zi/2023/"
  }
}
</route>

<template>
  <div>
    <div class="image-header flex-row flex-center">
      <div class="static-zi-image">
        <img
          v-bind="Rect1[0]"
          alt="Model wearing statement Zi Collection necklace by Paparazzi Accesories"
          class="hidden-mobile"
        />
      </div>
      <div class="zi-about-video flex-stretch">
        <iframe
          src="https://player.vimeo.com/video/1023370610?h=add588f286&title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479&amp;autoplay=1&amp;muted=1&amp;responsive=1"
          frameborder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          allowfullscreen
          title="Zi Collection 2024 Video"
        />
      </div>
      <div class="static-zi-image">
        <img
          v-bind="Rect2[0]"
          alt="Model wearing a sparkly necklace from Paparazzi Accessories Zi Collection"
          class="hidden-mobile"
        />
      </div>
    </div>
    <!-- <div class="flex-row flex-center">
      <img
        v-bind="Rect1[0]"
        alt="Model wearing statement Zi Collection necklace by Paparazzi Accesories"
        class="show-mobile banner-img-mobile"
      />
      <img
        v-bind="Rect2[0]"
        alt="Model wearing a sparkly necklace from Paparazzi Accessories Zi Collection"
        class="show-mobile banner-img-mobile"
      />
    </div> -->
    <div
      ref="signature"
      class="zi-section zi-signature flex-row flex-align-stretch"
    >
      <div class="flex-col flex-center narrow">
        <div class="product-area">
          <div class="flex-row flex-center">
            <img
              v-bind="ZiHeader[0]"
              alt="Paparazzi Accessories Zi Signature Logo"
              class="zi-signature-logo img-responsive"
            />
          </div>
          <div class="flex-row flex-center hidden-mobile">
            <router-link
              :to="{ name: 'shop', params: { path: 'zi-collection-2024' } }"
            >
              <Button class="grey"> Shop Now </Button>
            </router-link>
          </div>
          <div class="flex-row flex-center">
            <div class="zi-text extra-padding">
              <p>
                Unforgettably show stopping and irresistibly iconic, the Zi
                Collection is a unique line of exclusive statement pieces
                designed to dazzle. Each piece of the Zi Collection shines a
                little more brightly, sparkles a little more brilliantly, and
                flaunts as much attitude as the individual who wears it. These
                bold, exaggerated designs emphasize familiar characteristics
                that have shaped the original Paparazzi Collections and will
                undoubtedly leave a lasting impression. As founder, Misty Kirby
                says, the Zi Collection is the "BLING of all BLING!"
              </p>
            </div>
          </div>
          <div class="flex-row flex-center show-mobile show-mobile-btn">
            <Button class="grey">
              <router-link
                :to="{ name: 'shop', params: { path: 'zi-collection-2024' } }"
              >
                Buy Now
              </router-link>
            </Button>
          </div>
          <h3 class="zi-header">Zi Collection</h3>
          <div
            class="zi-pieces-link-container-four flex-row flex-center flex-wrap gap-md flex1"
          >
            <a
              v-for="(piece, index) of ziList.filter((p) => !p.signature)"
              :key="`pieceLink${index}`"
              @click.prevent="showPiecesModal(index)"
            >
              <img
                v-if="piece.item"
                v-bind="piece.item"
                sizes="180px"
                :alt="piece.name"
              />
              <div>{{ piece.name }}</div>
            </a>
          </div>
          <div class="flex-row flex-center">
            <div class="zi-text">
              <p>
                New Zi Collection pieces debut each fall during our annual
                convention. Known as the <em>Signature Series</em>, these
                stunning designs are named in honor of Consultants who pushed
                themselves beyond their comfort zone and right onto the catwalk.
              </p>
              <br />
              <p>
                Our Zi Collection models become the envy of the crowd as they
                get to unveil the gorgeous new designs to throngs of adoring
                fans. Their moment in the spotlight is then immortalized as
                their
                <em>Signature Series</em> piece becomes available to the masses.
                Think you have what it takes to be a Zi Collection model? Keep
                your eye out for the annual contest to claim your corner of the
                catwalk. With your name on everyone's lips, we'll have just one
                question for you: can we get your autograph?
              </p>
            </div>
          </div>
          <h3 class="zi-header">Zi Collection <em>Signature Series</em></h3>
        </div>
        <div class="product-area">
          <div
            class="zi-pieces-link-container flex-row flex-center flex-wrap gap-md flex1"
          >
            <a
              v-for="(piece, index) of ziList.filter((p) => p.signature)"
              :key="`pieceLink${index}`"
              @click.prevent="showPiecesModal(index + signatureCount)"
            >
              <img
                v-if="piece.item"
                v-bind="piece.item"
                sizes="180px"
                :alt="piece.name"
              />
              <div>The {{ piece.label || piece.name }}</div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <Dialog
      modal
      dismissable-mask
      :show-header="false"
      :draggable="false"
      v-model:visible="data.modalOpen"
      name="pieces"
      height="567px"
      class="pieces-modal"
    >
      <template #default>
        <div class="flex-row item-root">
          <a
            v-if="data.currentPieceIndex > 0"
            href="javascript:void(0);"
            class="zi-nav zi-piece-nav-prev"
            @click="scrollToPiece(data.currentPieceIndex - 1)"
          >
            <i class="pi pi-chevron-left" />
          </a>

          <transition ref="pieces" class="zi-pieces" v-if="piece" name="drive">
            <!-- :class="{ reverse: data.reverse }" -->
            <SignatureCard :key="piece.name" :piece="piece" />
          </transition>

          <a
            v-if="data.currentPieceIndex < ziList.length - 1"
            href="javascript:void(0);"
            class="zi-nav zi-piece-nav-next"
            @click="scrollToPiece(data.currentPieceIndex + 1)"
          >
            <i class="pi pi-chevron-right" />
          </a>
          <div v-else class="zi-nav zi-piece-nav-next" />
        </div>
      </template>
    </Dialog>
  </div>
</template>

<route lang="json">
{ "name": "zi" }
</route>

<script setup lang="ts">
import Rect1 from "@/assets/img/zi/Learn More Page/paparazzi-accessories-zi-collection-2024-sitting.jpg?preset=thumbnail";
import Rect2 from "@/assets/img/zi/Learn More Page/paparazzi-accessories-zi-collection-pink-dress.jpg?preset=thumbnail";
// import Rect1 from "@/assets/img/zi/2023/Learn More Page/Top/Left.png?preset=thumbnail";
// import Rect2 from "@/assets/img/zi/2023/Learn More Page/Top/Right.png?preset=thumbnail";
import ZiHeader from "@/assets/img/zi/ZiCollectionLogo_Silver.png?preset=thumbnail";
import SignatureCard from "@/components/zi/SignatureCard.vue";
import { useZiStore } from "@/stores/zi";
import type { ZiItem } from "@/stores/zi/zi_defs";
import { useHead } from "@unhead/vue";
import Button from "primevue/button";
import Dialog from "primevue/dialog";
import { computed, nextTick, onMounted, reactive } from "vue";

const zi = useZiStore();

useHead({
  title: "Shop the Zi Collection",
  meta: [
    {
      name: "description",
      content:
        "Discover the unforgettable Paparazzi Zi Collection—iconic statement pieces that dazzle and captivate.",
    },
  ],
  link: [
    {
      rel: "canonical",
      href: "https://paparazziaccessories.com/zi",
    },
  ],
});

onMounted(() => {
  zi.setup();
});
// TODO: metaInfo: { title: "Zi Collection" },

const data = reactive({
  modalOpen: false,
  currentPieceIndex: 0,
  reverse: false,
});

const ziList = computed<ZiItem[]>(() => {
  return zi.list.filter((i) => i.season === "2024" && i.listed);
});

const piece = computed(() => {
  return ziList.value[data.currentPieceIndex];
});
const signatureCount = computed(() => {
  return ziList.value.filter((p) => !p.signature).length;
});

function modalClosed() {
  data.modalOpen = false;
  document.body.classList.remove("modal-open");
}
async function scrollToPiece(index: number) {
  data.reverse = index < data.currentPieceIndex;
  await nextTick();
  data.currentPieceIndex = index;
}
function showPiecesModal(index: number) {
  data.currentPieceIndex = index;
  data.reverse = true;
  data.modalOpen = true;
}
</script>

<style>
.p-dialog.pieces-modal {
  width: calc(min(864px, 100%)) !important;
}
.p-dialog.pieces-modal .p-dialog-content {
  padding: 0;
  margin: 0;
}
</style>

<style scoped>
.page {
  gap: var(--1XL);
  margin: var(--XMd, 40px) auto var(--XMd, 40px);
}
h3.zi-header {
  color: var(--Black, #000);
  text-align: center;
  font-family: Indivisible;
  font-size: 18px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
  margin: 0;
}

.measured {
  width: 1120px;
  margin: auto;
  font-size: 14px;
  font-weight: 400;
  line-height: normal;
  padding-bottom: var(--1XL, 64px);
  span.bigpink {
    color: var(--Paparazzi-Pink, #ec008c);
    font-size: 32px;
    text-transform: uppercase;
    font-weight: 300;
  }
}
.zi-logo {
  padding: 10px;
}
.zi-logo,
.zi-signature-logo {
  max-width: 350px;
  padding: 0 var(--Sm, 24px) var(--Sm, 24px);
}
.zi-pieces {
  height: 100%;
}
.item-root {
  position: relative;
}
.zi-nav {
  position: absolute;
  top: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: black;
  width: 40px;
}
.zi-nav i {
  text-align: center;
  font-size: 12px;
}
.zi-piece-nav-prev {
  left: 0px;
}
.zi-piece-nav-next {
  right: 0px;
}
.zi-pieces-link-container {
  max-width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  margin: var(--Sm, 24px) auto 0 auto;
  justify-items: center;
  align-items: center;
}
.zi-pieces-link-container-four {
  max-width: 736px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  justify-items: center;
  align-items: center;
  margin: var(--Sm, 24px) auto 0 auto;
}

.zi-pieces-link-container a,
.zi-pieces-link-container-four a {
  display: inline-block;
  cursor: pointer;
  color: var(--Black, #000);
  text-align: center;
  /* Paragraph 1 */
  font-family: Indivisible;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-transform: capitalize;
}
.zi-pieces-link-container img,
.zi-pieces-link-container-four img {
  width: 160px;
  height: 200px;
  padding-bottom: var(--2XS, 8px);
}
.zi-sig-logo {
  width: 400px;
  margin-top: 15px;
  margin: auto;
}
.narrow {
  max-width: 1200px;
  margin: auto;
}
.narrow p {
  margin: 10px 0;
  text-align: center;
  max-width: 800px;
  margin: auto;
}
.zi-signature {
  margin-top: 5px;
  overflow: hidden;
}

.zi-text {
  max-width: 848px;
  padding: 40px 24px;
  p {
    color: var(--Black, #000);
    /* Paragraph 1 */
    font-family: Indivisible;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-align: left;
  }
}

.image-header {
  width: 1120px;
  height: 353px;
  background: #f0f0f0;
  overflow: hidden;
  justify-content: center;
  margin: 0 auto var(--XMd, 40px) auto;
}

/* .image-header img {
  object-position: top;
} */

.static-zi-image {
  width: 246px;
  overflow: hidden;
  img {
    width: 100%;
    min-height: 100%;
    max-width: 250px;
    object-fit: cover;
    object-position: top left;
  }
}
.static-zi-image:last-child {
  img {
    object-position: top right;
  }
}

.zi-about-video {
  flex: 0 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: stretch;
  align-items: stretch;
  z-index: 1;
}
.zi-about-video iframe,
.zi-about-video video {
  height: 353px;
  width: 628px;
  min-width: 300px;
  max-width: 100vh;
}
.product-area {
  width: 928px;
}

.show-mobile {
  display: none !important;
}

.banner-img-mobile {
  width: 100vw;
  height: 300px;
  background-size: cover;
  object-fit: cover;
  object-position: top;
}

@media (max-width: 1120px) and (min-width: 901px) {
  .image-header {
    width: 100vw;
    max-height: 307px;
  }
  .zi-about-video iframe,
  .zi-about-video video {
    height: 100%;
    width: 55vw;
    transform: scale(1.2);
    transform-origin: center;
  }
  .static-zi-image {
    width: 22.5vw;
    overflow: hidden;
    position: relative;
    left: -20px;
    img {
      max-width: 250px;
    }
  }
  .static-zi-image:last-child {
    left: 20px;
  }
}

@media (max-width: 900px) and (min-width: 801px) {
  .image-header {
    width: 100vw;
    max-height: 260px;
  }
  .zi-about-video iframe,
  .zi-about-video video {
    height: 100%;
    width: 50vw;
    transform: scale(1.2);
    transform-origin: center;
    overflow: hidden;
  }
  .static-zi-image {
    width: 25vw;
    overflow: hidden;
    transform-origin: center;
    position: relative;
    left: -20px;
    img {
      max-width: 250px;
    }
  }
  .static-zi-image:last-child {
    left: 20px;
  }
}

@media (max-width: 976px) and (min-width: 801px) {
  .product-area {
    width: 800px;
  }
  .zi-pieces-link-container[data-v-d9f947b9],
  .zi-pieces-link-container-four[data-v-d9f947b9] {
    grid-template-columns: repeat(auto-fill, minmax(134px, 1fr));
  }
  .zi-pieces-link-container img[data-v-d9f947b9],
  .zi-pieces-link-containe-four img[data-v-d9f947b9] {
    width: 100%;
    height: auto;
  }
}

@media (max-width: 800px) {
  .product-area {
    width: 100%;
  }
  .hidden-mobile {
    display: none !important;
  }
  .show-mobile {
    display: flex !important;
  }
  .show-mobile-btn {
    margin-bottom: var(--XMd, 40px);
  }
  .image-header {
    margin-bottom: 40px;
    height: min-content;
    width: 100%;
  }
  .zi-about-video {
    height: auto;
  }
  .zi-about-video iframe,
  .zi-about-video video {
    height: calc(100vw / 1.773);
    max-height: calc(100vw / 1.773);
    width: 100vw;
    max-width: 100vw;
    overflow: hidden;
  }
  .zi-logo,
  .zi-signature-logo {
    max-width: 300px;
    padding: 0 var(--Sm, 24px) 0;
  }
  .zi-text.extra-padding {
    padding: var(--Sm, 24px);
  }
  .zi-pieces-link-container,
  .zi-pieces-link-container-four {
    padding: 0 24px;
  }
  .zi-pieces-link-container-four {
    max-width: 100%;
  }
  .static-zi-image {
    display: none;
  }
}

@media (max-width: 551px) {
  .banner-img-mobile {
    height: 215px;
    overflow: hidden;
  }
  .image-header {
    max-height: 220px;
  }
}
</style>
